"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nginx = void 0;
var Nginx;
(function (Nginx) {
    Nginx[Nginx["Ok"] = 200] = "Ok";
    Nginx[Nginx["Created"] = 201] = "Created";
    Nginx[Nginx["Accepted"] = 202] = "Accepted";
    Nginx[Nginx["NoContent"] = 204] = "NoContent";
    Nginx[Nginx["PartialContent"] = 206] = "PartialContent";
    Nginx[Nginx["MovedPermanently"] = 301] = "MovedPermanently";
    Nginx[Nginx["MovedTemporarily"] = 302] = "MovedTemporarily";
    Nginx[Nginx["SeeOther"] = 303] = "SeeOther";
    Nginx[Nginx["NotModified"] = 304] = "NotModified";
    Nginx[Nginx["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    Nginx[Nginx["PermanentRedirect"] = 308] = "PermanentRedirect";
    Nginx[Nginx["BadRequest"] = 400] = "BadRequest";
    Nginx[Nginx["Unauthorized"] = 401] = "Unauthorized";
    Nginx[Nginx["PaymentRequired"] = 402] = "PaymentRequired";
    Nginx[Nginx["Forbidden"] = 403] = "Forbidden";
    Nginx[Nginx["NotFound"] = 404] = "NotFound";
    Nginx[Nginx["NotAllowed"] = 405] = "NotAllowed";
    Nginx[Nginx["NotAcceptable"] = 406] = "NotAcceptable";
    Nginx[Nginx["RequestTimeOut"] = 408] = "RequestTimeOut";
    Nginx[Nginx["Conflict"] = 409] = "Conflict";
    Nginx[Nginx["Gone"] = 410] = "Gone";
    Nginx[Nginx["LengthRequired"] = 411] = "LengthRequired";
    Nginx[Nginx["PreconditionFailed"] = 412] = "PreconditionFailed";
    Nginx[Nginx["RequestEntityTooLarge"] = 413] = "RequestEntityTooLarge";
    Nginx[Nginx["RequestUriTooLarge"] = 414] = "RequestUriTooLarge";
    Nginx[Nginx["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    Nginx[Nginx["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
    Nginx[Nginx["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    Nginx[Nginx["TooManyRequests"] = 429] = "TooManyRequests";
    Nginx[Nginx["InternalServerError"] = 500] = "InternalServerError";
    Nginx[Nginx["NotImplemented"] = 501] = "NotImplemented";
    Nginx[Nginx["BadGateway"] = 502] = "BadGateway";
    Nginx[Nginx["ServiceTemporarilyUnavailable"] = 503] = "ServiceTemporarilyUnavailable";
    Nginx[Nginx["GatewayTimeOut"] = 504] = "GatewayTimeOut";
    Nginx[Nginx["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    Nginx[Nginx["InsufficientStorage"] = 507] = "InsufficientStorage";
})(Nginx = exports.Nginx || (exports.Nginx = {}));
//# sourceMappingURL=nginx.js.map